import { parse, differenceInCalendarYears } from 'date-fns';

import store from '../store/index';

const customerFields = require('../settings/customerFields.json');
const customerSBFields = require('../settings/speedboat/customerFields.json');
const customerLBFields = require('../settings/labalaguere/customerField.json');
const countries = require('../settings/countries.json');

customerFields.country.items = countries;
customerFields.nationality.items = countries;

const emergencyContactsFields = require('../settings/emergencyContactsFields.json');
const identifiantsFields = require('../settings/identifiantsFields.json');
const identifiantsFieldsLB = require('../settings/labalaguere/identifiantsFields.json');

const rulesDefined = {
  age: value => {
    const dateInstance = new Date();
    const age = differenceInCalendarYears(dateInstance, parse(value, 'dd/MM/yyyy', dateInstance));
    if (age < 0 || age > 100) {
      return 'Âge invalide, merci de sélectionner une date <100 ans';
    }
    return true;
  },
  contactRequired: value => (!!this.$props.content.mobilephone || !!this.$props.content.telephone) || 'Champs contact requis',
  required: value => !!value || 'Champs Requis',
  name: value => {
    const pattern = /^([A-Za-z\u00C0-\u00D6\u00D8-\u00f6\u00f8-\u00ff\s'-]*)$/;
    return pattern.test(value) || 'Valeur Invalide';
  },
  date: value => {
    if (!value) {
      return true;
    }
    const pattern = /^([0]?[1-9]|[1|2][0-9]|[3][0|1])[/]([0]?[1-9]|[1][0-2])[/]([0-9]{4})$/;
    return pattern.test(value) || 'Date Invalide';
  },
  counter: value => value.length <= 20 || 'Max 20 characters',
  email: value => {
    if (!value) {
      return true;
    }
    const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return pattern.test(value) || 'Email Invalide';
  }
};

const fieldRules = fieldSettings => {
  const rules = [];

  if (fieldSettings.rules) {
    // Custom rules
    fieldSettings.rules.forEach(ruleName => {
      if (rulesDefined[ruleName]) {
        rules.push(rulesDefined[ruleName]);
      }
    });
  }

  return rules;
};

const getProjectContexts = () => {
  switch (store.getters.getBrand) {
    case 'crm':
      return customerSBFields.context.items;
    case 'crm_labalaguere':
      return customerLBFields.context.items;
    default:
      return [];
  }
};

const getCustomersFieldsByProject = () => {
  switch (store.getters.getBrand) {
    case 'crm':
      return { ...customerFields, ...customerSBFields };
    case 'crm_labalaguere':
      return { ...customerFields, ...customerLBFields };
    default:
      return customerFields;
  }
};

const getIdentifiantsFields = () => {
  switch (store.getters.getBrand) {
    case 'crm':
      return identifiantsFields;
    case 'crm_labalaguere':
      return { ...identifiantsFields, ...identifiantsFieldsLB };
    default:
      return identifiantsFields;
  }
};

// To fill collaborator form
const customerFieldsProperties = field => {
  const fieldsSettings = getCustomersFieldsByProject();

  if (!fieldsSettings[field]) return null;

  const fieldSettings = JSON.parse(JSON.stringify(fieldsSettings[field]));
  // const fieldSettings = customerFields[field];

  if (fieldSettings.rules && (fieldSettings.rules.includes('required') || fieldSettings.rules.includes('contactRequired'))) {
    fieldSettings.label += ' *';
  }

  const rules = fieldRules(fieldSettings);

  return { ...fieldSettings, rules: rules };
};

// To fill collaborator form
const emergencyContactsFieldsProperties = field => {
  const fieldSettings = JSON.parse(JSON.stringify(emergencyContactsFields[field]));
  // const fieldSettings = customerFields[field];

  if (fieldSettings.rules && (fieldSettings.rules.includes('required') || fieldSettings.rules.includes('contactRequired'))) {
    fieldSettings.label += ' *';
  }

  const rules = fieldRules(fieldSettings);

  return { ...fieldSettings, rules: rules };
};

// To fill collaborator form
const identifiantsFieldsProperties = field => {
  if (!getIdentifiantsFields()[field]) {
    return null;
  }
  const fieldSettings = JSON.parse(JSON.stringify(getIdentifiantsFields()[field]));
  // const fieldSettings = customerFields[field];

  if (fieldSettings.rules && (fieldSettings.rules.includes('required') || fieldSettings.rules.includes('contactRequired'))) {
    fieldSettings.label += ' *';
  }

  const rules = fieldRules(fieldSettings);

  return { ...fieldSettings, rules: rules };
};

export { customerFields, customerFieldsProperties, emergencyContactsFieldsProperties, identifiantsFieldsProperties, getProjectContexts };
